import { render, staticRenderFns } from "./televisionShow.vue?vue&type=template&id=713b76e0&scoped=true"
import script from "./televisionShow.vue?vue&type=script&lang=js"
export * from "./televisionShow.vue?vue&type=script&lang=js"
import style0 from "./televisionShow.vue?vue&type=style&index=0&id=713b76e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713b76e0",
  null
  
)

export default component.exports